// Gatsby requirements
import React from "react"
import { Script } from "gatsby"
import { storyblokEditable } from "gatsby-source-storyblok";

// Components
import RichTextRenderer from 'utils/richTextRenderer'

// Styles
import * as CSS from './sectionTable.module.scss'

const SectionTable = ({ blok }) => {

    return (
        <section 
            className={CSS.section}
            id={blok.anchorId}
            style={{
                backgroundColor: blok?.backgroundColor,
                paddingTop: blok?.removeTopMargin ? '0.5rem' : null,
                paddingBottom: blok?.removeBottomMargin ? '0.5rem' : null
            }}
            {...storyblokEditable(blok)}
        >

            <div className="wrapper">

                {blok.richtext &&
                    <RichTextRenderer data={blok.richtext} />
                }

                <Script strategy="idle" id="table" src="/scripts/table-sort.js" />

                <div className={CSS.tableWrapper}>
                    <table className={`${blok.backgroundColor === '#f1f1ef' ? CSS.white : ''} table-sort`}>
                        <thead>
                            <tr>
                                {blok.table.thead.map(loop => (
                                    <th>{loop.value}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {blok.table.tbody.map(loop => (
                                <tr>
                                    {loop.body.map(innerLoop => (
                                        <td>{innerLoop.value}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>

        </section>
    )
}

export default SectionTable